import type { DeliveryOutput } from '../data/api.js';

export type DeliveryRow = DeliveryOutput['rows'][number];

export interface DeliveryTreeNode {
  row: DeliveryRow;
  children: DeliveryTreeNode[];
}

function attach(
  byId: Map<string, DeliveryTreeNode>,
  roots: DeliveryTreeNode[],
  parentId: string | null,
  id: string,
): void {
  const node = byId.get(id);
  if (node === undefined) return;
  const parent = parentId === null ? undefined : byId.get(parentId);
  if (parent === undefined) roots.push(node);
  else parent.children.push(node);
}

export function expandableNodeIds(nodes: DeliveryTreeNode[]): string[] {
  return nodes.flatMap((node) =>
    node.children.length === 0 ? [] : [node.row.id, ...expandableNodeIds(node.children)],
  );
}

export function buildDeliveryTree(rows: DeliveryRow[]): DeliveryTreeNode[] {
  const byId = new Map<string, DeliveryTreeNode>(
    rows.map((row) => [row.id, { row, children: [] }]),
  );
  const roots: DeliveryTreeNode[] = [];

  for (const row of rows) {
    if (row.level === 'campaign') {
      const node = byId.get(row.id);
      if (node !== undefined) roots.push(node);
      continue;
    }
    const parentId = row.level === 'adset' ? row.campaignId : row.parentId;
    attach(byId, roots, parentId, row.id);
  }

  return roots;
}
